import * as React from 'react';
import { useState } from 'react';
import { Col, Row, Form, Nav, Card, Button, ListGroup, Badge, Alert, Modal, Spinner } from "react-bootstrap";
import atlasApi from "../utils/atlasapi";


export interface diagProps {
	setup: boolean;
	onClose: (value: string) => void;
	onConfirm: (value: string) => void;
}

export default function DialogDeleteScenario(props: diagProg) {
	const [status, setStatus] = useState({sent:null, message:''});
	const {onClose, onConfirm, setup} = props;
	
	const handleClose = (resp) => {
		onClose(resp);
		if(setup.onClose)
			setup.onClose(resp);
		setStatus({sent:null, success:false, message:''});
	};

	const handleConfirm = (data) => {
		setStatus({sent:false, success:false, message:'Deleting...'});
		
		//saveguard for testing
		if(!setup.scenario.scenario_id && !setup.scenario.scenarioid)
			return;
		//console.log(scenario);
		atlasApi.deleteScenario(setup.scenario, setup.user.userDetails).then((response)=>{
			//console.log(response);
			if(response && response.success){
				setStatus({sent:true, success:true, message:'This scenario was deleted'});
				//redirect without timout
				setTimeout(() => {
					handleClose(response);
				}, 2000);
			}
			else
				setStatus({sent:true, success:false, message:'Error deleting scenario'});
		}).catch((e)=>{
			setStatus({sent:true, success:false, message:'Error deleting scenario'});
		});
	};
	
	return (
		<Modal show={setup.open} onHide={handleClose} dialogClassName={(setup.stack ? 'stack' : '')} backdropClassName={(setup.stack ? 'stack' : '')} centered>
			<Modal.Header closeButton>
				<Modal.Title>Delete Scenario</Modal.Title>
			</Modal.Header>

			{status.sent === null ? (
				<React.Fragment>
					<Modal.Body>
						<Row className="">
							<Col xs="12" className="dialog-feedback-icon text-center">
								<i className="ri-error-warning-line text-warning" />
							</Col>
							<Col xs="12" className="dialog-feedback-text mb-5">
								You are about to delete <strong>'{setup.scenario ? setup.scenario.name : ''}'</strong> scenario.
							</Col>
						</Row>
					</Modal.Body>
					<Modal.Footer>
						<Button className="me-auto" variant="secondary" onClick={handleClose}>Close</Button>
						<Button variant="danger" onClick={handleConfirm}>Delete scenario</Button>
					</Modal.Footer>
				</React.Fragment>
			) : (
			<Modal.Body>
				<Row className="mb-3 dialog-feedback">
					<Col xs="12" className="dialog-feedback-icon text-center">
						{
						status.sent ?
							(status.success ? 
								(<i className="ri-checkbox-circle-line text-success"></i>)
								:
								(<i className="ri-error-warning-line text-warning"></i>)
							)
							:
							(<Spinner animation="border" variant="info" className="mt-5" />)
						}
					</Col>
					<Col xs="12" className="dialog-feedback-text mb-5">
						{status.message}
					</Col>
				</Row>
			</Modal.Body>	
			)}
		</Modal>
	);
} 
